export default __webpack_public_path__ + "static/media/image.cookoo-eats.dc951e7a.png";